'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const formatSurveyReference = survey => {
  return new ReferenceRecord({
    id: survey.surveyId,
    label: survey.title,
    referencedObject: fromJS(survey)
  });
};
const formatSurveys = surveys => {
  return indexBy(get('id'), List(surveys).map(formatSurveyReference));
};
export default formatSurveys;